import { render, staticRenderFns } from "./DownloadFileButton.vue?vue&type=template&id=4fec707a&scoped=true"
import script from "./DownloadFileButton.vue?vue&type=script&lang=ts"
export * from "./DownloadFileButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fec707a",
  null
  
)

export default component.exports